import { v4 as uuidv4 } from "uuid";
import classNames from "classnames";
import { Helmet } from "react-helmet";

import GoogleButton from "views/uikit/GoogleButton";
import { PRIVATE_DATASETS_PATH } from "helpers/constants/paths";

import { isAnonymousUser, selectUser } from "redux/authReducer";
import { setShowMobileErrorModal } from "redux/Modals/actions";

import githubLogo from "assets/img/github-logo.svg";
import googleLogo from "assets/img/google-logo.svg";

import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import {
  useWindowResize,
  isMobileDevice,
  isFastdupUser,
  isOnPremUser,
} from "helpers/utility/utilities";
import { composeApiURL } from "helpers/utility/axiosHelpers";

import styles from "./style.module.scss";

const LoginButtons = () => {
  const showGithubButton = !isFastdupUser() && !isOnPremUser();
  const showGoogleButton = !isOnPremUser();
  const showSSOButton = isOnPremUser();

  const googleLoginButtonClassnames = classNames(
    styles.loginButton,
    styles.googleBtn
  );

  const generateGithubSSOUrl = () => {
    // In canary we don't have a github client so we're using the production one
    const redirectHost =
      window.location.host === "app.visual-layer.link"
        ? "app.visual-layer.com"
        : window.location.host;
    let redirectURI = "https://" + redirectHost + "/api/v1/github-sso";
    redirectURI += "?referrer=" + window.location.href;
    return (
      "https://github.com/login/oauth/authorize?scope=user&client_id=" +
      process.env.REACT_APP_GITHUB_CLIENT_ID +
      "&state=" +
      uuidv4() +
      "&redirect_uri=" +
      redirectURI
    );
  };

  const generateSSOUrl = () => {
    return composeApiURL(process.env.REACT_APP_API_ENDPOINT!, "/oidc/login");
  };

  return (
    <div className={styles.loginButtons}>
      {showGithubButton && (
        <div className={styles.loginButtonWrapper}>
          <a className={styles.loginButton} href={generateGithubSSOUrl()}>
            <img src={githubLogo} alt="github-login-button-logo" />
            <span>Log in with Github</span>
          </a>
        </div>
      )}
      {showGoogleButton && (
        <div className={styles.loginButtonWrapper}>
          <div className={googleLoginButtonClassnames}>
            <img src={googleLogo} alt="google-login-button-logo" />
            <span>Log in with Google</span>
          </div>
          <div className={styles["google-auth-login"]}>
            <GoogleButton />
            <div
              className="g_id_signin"
              data-width={400}
              data-height={48}
            ></div>
          </div>
        </div>
      )}

      {showSSOButton && (
        <div className={styles.loginButtonWrapper}>
          <a className={styles.loginButton} href={generateSSOUrl()}>
            <span>Log in with SSO</span>
          </a>
        </div>
      )}
    </div>
  );
};

const Login = () => {
  const { width } = useWindowResize();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //REMOVE CONDITION WHEN TWEAKING WITHOUT TOKENS IS NOT NEEDED ANYMORE
  if (process.env.REACT_APP_IS_AUTHENTICATION_DISABELED === "false") {
    let user = selectUser();
    if (user && !isAnonymousUser()) {
      window.location.href = PRIVATE_DATASETS_PATH;
    }
  }

  useEffect(() => {
    if (localStorage.getItem("disclaimer-shown")) {
      return;
    }

    if (isMobileDevice()) {
      dispatch(setShowMobileErrorModal(true));
      localStorage.setItem("disclaimer-shown", "true");
    } else {
      dispatch(setShowMobileErrorModal(false));
    }
    // eslint-disable-next-line
  }, [width]);

  const handleFreeAccessClick = () => {
    //TBD: add validations  if needed
    navigate("/free-trial");
  };

  return (
    <div className={styles.loginContainer}>
      <Helmet>
        <title>Login</title>
        <script
          src="https://accounts.google.com/gsi/client"
          async
          defer
        ></script>
      </Helmet>
      <div className={styles.loginTitleContainer}>
        <div className={styles.loginTitle}>Get started</div>
        <div className={styles.loginDescription}>
          Sign in to enjoy the features of Visual Layer
        </div>
      </div>
      <LoginButtons />
      <div className={styles.agreeTerms}>
        By Signing In, I Agree To The{" "}
        <a
          href={"https://visual-layer2.readme.io/docs/terms-of-service"}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          Terms And Conditions
        </a>{" "}
        And{" "}
        <a
          href={"https://visual-layer2.readme.io/docs/privacy-policy"}
          target="_blank"
          rel="noreferrer"
          className={styles.link}
        >
          The Privacy Policy
        </a>
      </div>

      <div
        className={styles.freeAccessContainer}
        onClick={handleFreeAccessClick}
      >
        <span>Don't have an account? </span>
        <span className={styles.link}>Unlock Free Access</span>
      </div>
    </div>
  );
};

export default Login;
